import { render } from "./TheAsset.vue?vue&type=template&id=0e639335&scoped=true&ts=true"
import script from "./TheAsset.vue?vue&type=script&lang=ts"
export * from "./TheAsset.vue?vue&type=script&lang=ts"

import "./TheAsset.vue?vue&type=style&index=0&id=0e639335&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e639335"]])

export default __exports__